export default __webpack_public_path__ + "static/media/mor-chaluz-bk.3d7c4ae6.png";